export function usePriceDisplay(saleValue: number, overridePrice?: number) {
  // overridePrice pode ser > saleValue (spread FastPass na listagem) — exibe sem guard
  const displayPrice = overridePrice ?? saleValue;
  // hasDiscount só é true quando há desconto real (FastPass offer, preço menor)
  const hasDiscount = overridePrice !== undefined && overridePrice < saleValue;
  return { displayPrice, hasDiscount };
}
